import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND_MUTATION } from '../graphql/mutations'
import { UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND } from '../redux/action-types'

const useUpdateLocationCuisineTypeAndLocationTypeSameAsBrandMutation = () => {
  const dispatch = useDispatch()

  const { updateError } = useSelector(
    store => store.brandCurationTasks.brandCurationTask,
  )

  const mutate = useCallback(
    (id, areLocationCuisineTypeAndLocationTypeSameAsBrand) =>
      apolloService.mutate({
        mutation:
          UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND_MUTATION,
        variables: { id, areLocationCuisineTypeAndLocationTypeSameAsBrand },
        dispatch,
        action: UPDATE_LOCATION_CUISINE_TYPE_AND_LOCATION_TYPE_SAME_AS_BRAND,
      }),
    [dispatch],
  )

  return [mutate, { updateError }]
}

export default useUpdateLocationCuisineTypeAndLocationTypeSameAsBrandMutation
